import { render, staticRenderFns } from "./Todolist.vue?vue&type=template&id=bad172be&"
import script from "./Todolist.vue?vue&type=script&lang=js&"
export * from "./Todolist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports